const STASH_KEY = 'xengolf.pendingSocietyJoin'
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

interface PendingSocietyJoin {
  code: string
  storedAt: number
}

/**
 * localStorage stash carrying a society join code across the auth wall (registration, OAuth
 * full-page redirects, the profile-completion hard navigation). localStorage — not
 * sessionStorage — because OAuth and profile completion replace the browsing context.
 */
export const stashPendingSocietyJoin = (code: string): void => {
  try {
    const stash: PendingSocietyJoin = {code: code.trim(), storedAt: Date.now()}
    localStorage.setItem(STASH_KEY, JSON.stringify(stash))
  } catch {
    // Quota/private-browsing failures must not break the landing page; manual entry remains.
  }
}

export const peekPendingSocietyJoin = (): string | null => {
  try {
    const raw = localStorage.getItem(STASH_KEY)
    if (!raw) return null
    const stash = JSON.parse(raw) as PendingSocietyJoin
    if (!stash.code || typeof stash.storedAt !== 'number' || Date.now() - stash.storedAt > MAX_AGE_MS) {
      localStorage.removeItem(STASH_KEY)
      return null
    }
    return stash.code
  } catch {
    clearPendingSocietyJoin()
    return null
  }
}

export const clearPendingSocietyJoin = (): void => {
  try {
    localStorage.removeItem(STASH_KEY)
  } catch {
    // ignore
  }
}
